import { MotherOrderList_orders_edges_node } from "@saleor/motherOrders/types/MotherOrderList";
import * as React from "react";

import AddressField from "./AddressField";

interface CustomerCellProps {
  order: MotherOrderList_orders_edges_node;
  setOpenAddressToolTip: (data: boolean) => void;
}

const CustomerCell: React.FC<CustomerCellProps> = props => {
  const { order, setOpenAddressToolTip } = props;
  return (
    <>
      <span style={{ whiteSpace: "nowrap" }}>
        {order?.user?.firstName} {order?.user?.lastName}{" "}
      </span>
      <br />
      <span>{order?.user?.contactNo}</span>
      <br />
      <AddressField
        address={order?.shippingAddress?.streetAddress1}
        enableToolTip={true}
        setOpenAddressToolTip={setOpenAddressToolTip}
      />
      {/* <Tooltip
          placement="bottom"
          title={`${order?.shippingAddress?.streetAddress1}`}
          // disableHoverListener={isOverflowed === false}
          interactive
          onOpen={() => setOpenAddressToolTip(true)}
          onClose={() => setOpenAddressToolTip(false)}
        >
          <div onClick={e => e.stopPropagation()}>
            <div
              style={{
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
                display: "-webkit-box",
                overflow: "hidden",
                width: "10em"
                // whiteSpace: "nowrap",
                // textOverflow: "ellipsis"
              }}
            >
              <span>
                {order?.shippingAddress?.streetAddress1}{" "}
              </span>
            </div>
          </div>
        </Tooltip> */}
    </>
  );
};

export default CustomerCell;
